import React, { useState } from 'react';
import './UserForm.css';
import Input from './common/Input';
import Select from './common/Select';
import Button from './common/Button';

export default function UserForm({ initialValues = {}, onSubmit, onCancel }) {
  const [values, setValues] = useState({
    name: initialValues.name || '',
    email: initialValues.email || '',
    role: initialValues.role || 'user',
    password: ''
  });

  function change(e) {
    const { name, value } = e.target;
    setValues(prev => ({ ...prev, [name]: value }));
  }

  function submit(e) {
    e.preventDefault();
    const payload = { name: values.name, email: values.email, role: values.role };
    if (values.password) payload.password = values.password;
    onSubmit(payload);
  }

  return (
    <form className="user-form" onSubmit={submit}>
      <Input
        label="İsim"
        name="name"
        value={values.name}
        onChange={change}
        required
      />

      <Input
        label="E-posta"
        name="email"
        type="email"
        value={values.email}
        onChange={change}
        required
      />

      <Select
        label="Rol"
        name="role"
        value={values.role}
        onChange={change}
      >
        <option value="user">User</option>
        <option value="admin">Admin</option>
      </Select>

      <Input
        label="Parola (yeni/şifre değişikliği)"
        name="password"
        type="password"
        value={values.password}
        onChange={change}
      />

      <div className="form-actions">
        <Button type="submit">Kaydet</Button>
        <Button type="button" variant="secondary" onClick={onCancel}>
          İptal
        </Button>
      </div>
    </form>
  );
}
